export interface RegistrationPartsWarranty {
  excludedApplianceCodes?: string[];
  partsWarrantyInMonths: number;
}
